import {
  startRegistration,
  startAuthentication,
  browserSupportsWebAuthn,
  browserSupportsPasskeys,
  browserSupportsWebAuthnAutofill,
  WebAuthnAbortService,
  type RegistrationResponseJSON,
  type AuthenticationResponseJSON,
} from "@simplewebauthn/browser";

export {
  browserSupportsWebAuthn,
  browserSupportsPasskeys,
  browserSupportsWebAuthnAutofill,
  WebAuthnAbortService,
};

export async function performPasskeyRegistration(options: any): Promise<RegistrationResponseJSON> {
  return startRegistration({ optionsJSON: options });
}

export async function performPasskeyAuthentication(options: any): Promise<AuthenticationResponseJSON> {
  return startAuthentication({
    optionsJSON: options,
    useBrowserAutofill: options.mediation === "conditional",
    verifyBrowserAutofillInput: false,
  });
}
